import { Typography } from 'antd'
import { RolodexDocumentEntry } from 'features/files/types'
import * as React from 'react'
import styled from 'styled-components'

import { DocumentListItem } from './DocumentListItem'

const { Text } = Typography

export interface DocumentListProps {
  documents: ReadonlyArray<RolodexDocumentEntry>
  selectedDocumentId?: string | null
  onDocumentSelect?: (documentId: string) => void
  onDocumentPreview?: (documentId: string) => void
  className?: string
  size?: 'large' | 'small'
  onDelete?: (documentId: string) => Promise<void>
  afterItem?: (document: RolodexDocumentEntry) => React.ReactNode
}

const Container = styled.div`
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 32px 0;
`

export const DocumentList: React.FC<DocumentListProps> = ({
  documents,
  selectedDocumentId,
  onDocumentSelect,
  className,
  size = 'large',
  onDelete,
  afterItem,
}) => {
  if (documents.length === 0) {
    return (
      <Container className={className}>
        <Text
          strong
          style={{ fontSize: 16, marginBottom: 12, display: 'block' }}>
          Documents
        </Text>
        <EmptyState>
          <Text type='secondary'>No documents found</Text>
        </EmptyState>
      </Container>
    )
  }

  return (
    <Container className={className}>
      <div>
        {documents.map((document) => (
          <DocumentListItem
            key={document.entry_id}
            document={document}
            selected={document.entry_id === selectedDocumentId}
            onSelect={onDocumentSelect || (() => {})}
            size={size}
            onDelete={onDelete}
            after={afterItem?.(document)}
          />
        ))}
      </div>
    </Container>
  )
}
